// Site footer (Oct 2026): legal links + links to our outside shops.
import { Link } from "react-router-dom";

export const SHOP_LINKS = {
  etsy: "https://legendarychess.etsy.com",
  gumroad: "https://4xlegendarychess.gumroad.com",
  instagram: "https://www.instagram.com/4xlegendarychess",
};

export default function SiteFooter() {
  return (
    <footer className="site-footer" data-testid="site-footer">
      <div className="site-footer-row">
        <Link to="/terms" data-testid="footer-terms">Terms</Link>
        <Link to="/privacy" data-testid="footer-privacy">Privacy</Link>
        <Link to="/refunds" data-testid="footer-refunds">Refunds</Link>
        <Link to="/about" data-testid="footer-about">About</Link>
      </div>
      <div className="site-footer-row">
        <span className="site-footer-label">Shop &amp; follow:</span>
        <a href={SHOP_LINKS.etsy} target="_blank" rel="noopener noreferrer" data-testid="footer-etsy">Etsy</a>
        <a href={SHOP_LINKS.gumroad} target="_blank" rel="noopener noreferrer" data-testid="footer-gumroad">Gumroad</a>
        <a href={SHOP_LINKS.instagram} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram">Instagram</a>
      </div>
      <p className="site-footer-copy">© 2026 4X Legendary Chess. All rights reserved.</p>
    </footer>
  );
}
